import {Template, Component, Attribute} from '@scoutgg/ftw/source/lib'
import template from './match-controls.jade'
import {Http, Match} from '../../models'
import '@scoutgg/ftw/source/atoms/button/button'
import notify from '@scoutgg/ftw/source/services/notification'

@Component('sporty')
@Template(template)
@Attribute('match', Match)
export default class MatchControls extends HTMLElement {
  attached() {
  }

  get matchId() {
    var match = this.match || document
      .querySelector('sporty-claimed-matches')
      .match
    return match && match._id
  }

  sendAll() {
    if(this.isDisabled) return
    this.isDisabled = true
    this.render()

    var ids = document
      .querySelector('sporty-claimed-matches')
      .realMatches
      .map(m => m._id)
    var promise = Http.post(['feeds', 'all', 'events'].join('/'), {ids})

    promise
      .then(() => {
        notify(`Sending of events has started`, {
          level: 'success',
          timeout: 5000,
        })
      })
      .catch(err => {
        notify(err.message, {
          level: 'danger',
          timeout: 10000,
        })
      })
      .then(() => {
        this.isDisabled = false
        this.render()
      })
  }
}
